function getConfigCompoment () { return 'BulkFilesFactory' }
function getStandardAttributes () { return null }

export default {
  getConfigCompoment,
  getStandardAttributes
}
